import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignJourneyHandoff } from '@/pages/workspaces/automations/[campaignId]/journeys/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journeys/',
)({
  component: JourneysCampaignJourneyHandoff,
});
